import { render, staticRenderFns } from "./PresentationsForm.vue?vue&type=template&id=a5b19da2&scoped=true&lang=pug&"
import script from "./PresentationsForm.vue?vue&type=script&lang=js&"
export * from "./PresentationsForm.vue?vue&type=script&lang=js&"
import style0 from "./PresentationsForm.vue?vue&type=style&index=0&id=a5b19da2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b19da2",
  null
  
)

export default component.exports